import CustomerUptimeListResourceListResultModel from '../../generated/types/model/resource/CustomerUptimeListResourceListResultModel';

export default class CustomerUptimeListResourceListResultViewModel extends CustomerUptimeListResourceListResultModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
